export const reportSliderData = {
  Posture: [
    {
      id: 1,
      src: 'images/Report_Posture_01.png',
      alt: 'Posture 1'
    },
    {
      id: 2,
      src: 'images/Report_Posture_02.png',
      alt: 'Posture 2'
    },
    {
      id: 3,
      src: 'images/Report_Posture_03.png',
      alt: 'Posture 3'
    }
  ],
  Manual: [
    {
      id: 1,
      src: 'images/Report_Manual_01.png',
      alt: 'Posture 1'
    },
    {
      id: 2,
      src: 'images/Report_Manual_02.png',
      alt: 'ROM 1'
    }
  ],
  ROM: [
    {
      id: 1,
      src: 'images/Report_Rom_01.png',
      alt: 'ROM 1'
    },
    {
      id: 2,
      src: 'images/Report_Rom_02.png',
      alt: 'ROM 2'
    },
    {
      id: 3,
      src: 'images/Report_Rom_03.png',
      alt: 'ROM 3'
    }
  ],
  Moire: [
    {
      id: 1,
      src: 'images/Report_Moire.png',
      alt: 'Moire 1'
    }
  ],
  Movement: [
    {
      id: 1,
      src: 'images/Report_Squat_01.png',
      alt: 'Movement 1'
    },
    {
      id: 2,
      src: 'images/Report_Squat_02.png',
      alt: 'Movement 2'
    },
    {
      id: 3,
      src: 'images/Report_Squat_03.png',
      alt: 'Movement 3'
    }
  ]
};
